// extracted by mini-css-extract-plugin
module.exports = {"meal":"Meals_meal__2ld89","detail_btn":"Meals_detail_btn__hUZ3k","list_title":"Meals_list_title__3sULh"};